import IHocContext from '@@types/IHocContext';

import Context from '~/stores/context';
import { observer } from 'mobx-react';
import { IReactComponent } from 'mobx-react/dist/types/IReactComponent';
import { observer as functionObserver } from 'mobx-react-lite';
import { FC } from 'react';
import * as React from 'react';

export function createHocWithMobx(Ctx) {
  return function hocFunction<T>(WrappedComponent: IReactComponent<T & IHocContext> | FC<T & IHocContext>) {
    const componentName = WrappedComponent.name || WrappedComponent.displayName;

    const ObservedComponent =
      // @ts-ignore
      WrappedComponent.render || WrappedComponent.prototype?.render
        ? observer(WrappedComponent)
        : functionObserver(WrappedComponent as FC);

    const HocWithMobxComp = React.forwardRef<any, T>((props: T, ref: any) => {
      const extendedProps = {
        ...props,
        data: Ctx.stores,
        uiState: Ctx.uiState,
        actions: Ctx.actions,
        utils: Ctx.utils,
        ref,
      };

      return <ObservedComponent {...extendedProps} />;
    });

    HocWithMobxComp.displayName = componentName;
    return HocWithMobxComp as React.FC<Omit<T, keyof IHocContext>>;
  };
}

export default createHocWithMobx(Context);
